import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, where, orderBy, limit, startAfter, endBefore, onSnapshot, arrayUnion, arrayRemove, deleteField, getCountFromServer } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { EVENT_TYPES } from "@/constants/eventTypes";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";
import { requestEndPoint } from '@/store/Api'

Vue.use(VueAxios, Axios);

const db = getFirestore();

const storageInstance = getStorage()
const storage = ref(storageInstance, "proTrainerVideos/");
const storageImages = ref(storageInstance, "proTrainerPreviewImages/");

export default {
    state: {
        loadingStatus: 0,
        statusImage: 0,
        statusSocialSharingImage: 0,
        proTrainersList: [],
        proTrainersCounterReproductor: {},
        unsubscribeProTrainersList: null,
        unsubscribeProTrainersCounterReproductor: null,
        dateRange: {
            startDate: new Date(new Date().setHours(0, 0, 0, 0)),
            endDate: new Date(new Date().setHours(23, 59, 59, 999))
        },
        dateRangeChart: {
            startDate: new Date(new Date().setHours(0, 0, 0, 0)),
            endDate: new Date(new Date().setHours(23, 59, 59, 999))
        },
        proTrainerFilters: [],
        proTrainerLeaderboard: [],
        proTrainerTypeOfExercise: [],
        proTrainerTypeOfBody: [],
    },
    mutations: {
        SET_VALUE_LOADING_STATUS(state, value) {
            state.loadingStatus = value
        },
        SET_VALUE_LOADING_IMAGE(state, value) {
            state.statusImage = value
        },
        SET_VALUE_LOADING_SOCIAL_SHARING_IMAGE(state, value) {
            state.statusSocialSharingImage = value
        },
        SET_PRO_TRAINERS_LIST(state, proTrainersList) {
            state.proTrainersList = proTrainersList;
        },
        SET_PRO_COUNTER_REPRODUCTOR(state, counterReproductor) {
            state.proTrainersCounterReproductor = counterReproductor;
        },
        SET_UNSUBSCRIBE_PRO_TRAINERS_LIST(state, unsubscribe) {
            state.unsubscribeProTrainersList = unsubscribe;
        },
        GO_UNSUBSCRIBE_PRO_TRAINERS_LIST(state) {
            state.unsubscribeProTrainersList();
        },
        SET_UNSUBSCRIBE_PRO_TRAINERS_COUNTER_REPRODUCTOR(state, unsubscribe) {
            state.unsubscribeProTrainersCounterReproductor = unsubscribe;
        },
        GO_UNSUBSCRIBE_PRO_TRAINERS_COUNTER_REPRODUCTOR(state) {
            state.unsubscribeProTrainersCounterReproductor();
        },
        SET_DATE_RANGE(state, dateRange) {
            state.dateRange = dateRange
        },
        SET_DATE_RANGE_CHART(state, dateRangeChart) {
            state.dateRangeChart = dateRangeChart
        },
        SET_PRO_TRAINERS_FILTER_LIST(state, proTrainerFilters) {
            state.proTrainerFilters = proTrainerFilters
        },
        ADD_ANY_VALUE_PRO_TRAINERS_FILTER_LIST(state, data) {
            let indexPrincipal = state.proTrainerFilters.findIndex(filter => filter.type === data.doc)
            // state.proTrainerFilters[indexPrincipal][data.array].unshift(data.name)
            state.proTrainerFilters[indexPrincipal].listFilters.push({ name: data.name, children: data.children })
        },
        DELETE_ANY_VALUE_PRO_TRAINERS_FILTER_LIST(state, data) {
            let indexPrincipal = state.proTrainerFilters.findIndex(filter => filter.type === data.doc)
            let index = state.proTrainerFilters[indexPrincipal].listFilters.indexOf(data.item.name)
            // state.proTrainerFilters[indexPrincipal][data.array].splice(index, 1)
            state.proTrainerFilters[indexPrincipal].listFilters.splice(index, 1)
        },
        UPDATE_WITH_NEW_VALUES_PRO_TRAINERS_FILTER_LIST_CHILDREN(state, data) {
            let indexPrincipal = state.proTrainerFilters.findIndex(filter => filter.type === data.doc)
            state.proTrainerFilters[indexPrincipal].listFilters = data.updatedArray
        },
        UPDATE_FILTER_LIST_PRO_TRAINER(state, data) {
            state.proTrainerFilters.push({
                type: data.doc,
                listFilters: data.listFilters,
                name: data.name
            })
        },
        DELETE_VALUE_ROOT_FILTER_PRO_TRAINER(state, data) {
            let indexPrincipal = state.proTrainerFilters.findIndex(filter => filter.type === data.doc)
            state.proTrainerFilters.splice(indexPrincipal, 1)
        },
        SET_ACTUAL_LEADERBOARD(state, leaderboard) {
            state.proTrainerLeaderboard = leaderboard
        },
        SET_PRO_TRAINER_TYPE_OF_EXERCISE_LIST(state, proTrainerTypeOfExercise) {
            state.proTrainerTypeOfExercise = proTrainerTypeOfExercise
        },
        SET_PRO_TRAINER_TYPE_OF_BODY_LIST(state, proTrainerTypeOfBody) {
            state.proTrainerTypeOfBody = proTrainerTypeOfBody
        }
    },
    actions: {
        QueryForCreateLeaderboardsCollection({ }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "proTrainersList"))
                    let proTrainersList = [];
                    let i = 0
                    querySnapshot.forEach(async (doc) => {
                        let proTrainer = doc.data();
                        proTrainersList.push(proTrainer);
                        await setDoc(doc(db, "leaderboards", doc.id), {
                            workout: doc(db, "proTrainersList", doc.id),
                            workoutName: proTrainer.name
                        })
                        i++
                        console.log('workout updated:', i)
                    });
                    console.log(proTrainersList);
                    resolve(proTrainersList);
                } catch (error) {

                }
            })

        },
        GetProTrain({ }, proTrain) {
            return new Promise(async (resolve, reject) => {
                try {
                    let resProTrain = await getDoc(doc(db, "proTrainersList", proTrain.id))
                    let gettedProTrain = resProTrain.data()
                    if (gettedProTrain.subscription && gettedProTrain.subscription != "") {
                        let subscription = await getDoc(doc(db, "subscriptionsList", gettedProTrain.subscription.id))
                        gettedProTrain.subscription = subscription.data()
                    }
                    gettedProTrain.endDay = gettedProTrain.endDay ? gettedProTrain.endDay.toDate() : ''
                    resolve(gettedProTrain)
                } catch (error) {
                    reject(error)
                }
            })
        },
        UploadVideoProTrainer({ commit }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `proTrainerVideos/${random}`);
                    let bytes = new Blob([new Uint8Array(proTrainer.principalVideo.blob)]);
                    console.log('storageRef', storageRef.name);
                    let metadata = {
                        contentType: 'video/mp4'
                    }

                    // Upload the bytes
                    await uploadBytes(storageRef, bytes, metadata);

                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadImagePreviewProTrainer({ commit }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `proTrainerPreviewImages/${random}`);
                    console.log('storageRef', storageRef.name);

                    // Upload the string
                    await uploadString(storageRef, proTrainer.selectedImagePreview.img, "data_url");

                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadSocialSharingImageProTrainer({ commit }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `proTrainerPreviewImages/${random}`);
                    console.log('storageRef', storageRef.name);

                    // Upload the string
                    await uploadString(storageRef, proTrainer.socialSharingImage.img, "data_url");

                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateSetProTrainer({ }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                delete proTrainer.principalVideo.video
                delete proTrainer.selectedImagePreview.img
                if (proTrainer.socialSharingImage.img) {
                    delete proTrainer.socialSharingImage.img
                }
                if (proTrainer.subscription && proTrainer.subscription != "") {
                    proTrainer.subscription = doc(db, "subscriptionsList", proTrainer.subscription.id)
                }
                const newDocRef = doc(collection(db, "proTrainersList"));
                proTrainer.id = newDocRef.id;
                proTrainer.createdAt = new Date()
                proTrainer.updatedAt = new Date()
                await setDoc(newDocRef, proTrainer)
                    .then(async (res) => {
                        await updateDoc(doc(db, "countersAnalytics", "workoutReproductions"), {
                            [newProTrainer.id]: 0
                        })
                            .then(async (resCounter) => {
                                console.log('newProTrainer.id', newProTrainer.id);
                                await setDoc(doc(db, "leaderboards", newProTrainer.id), {
                                    workout: doc(db, "proTrainersList", newProTrainer.id),
                                    workoutName: proTrainer.name
                                })
                                resolve(newDocRef.id);
                            })
                            .catch((errCounter) => {
                                reject(errCounter);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        async UpdateSize({ dispatch }) {
            return new Promise(async (resolve, reject) => {
                //915195
                //1161521 1.1MB
                // const calcule = await dispatch('GetSizeFile', 1161521)
                // console.log(calcule);
                const querySnapshot = await getDocs(collection(db, "proTrainersList"))
                let i = 0
                querySnapshot.forEach(async (doc) => {
                    const id = doc.id
                    let proTrainer = doc.data();
                    let referenceImg = ref(storageInstance, proTrainer.selectedImagePreview.ref)
                    let referenceVideo = ref(storageInstance, proTrainer.principalVideo.ref)
                    let referenceSocial = ref(storageInstance, proTrainer.socialSharingImage.ref)

                    // Note: getDownloadURL doesn't return metadata, this needs to be refactored
                    // For now, we'll skip the size calculation
                    let sizeImg = 0
                    let sizeVideo = 0
                    let sizeSocial = 0

                    await updateDoc(doc(db, "proTrainersList", id), {
                        'principalVideo.size': sizeVideo,
                        'principalVideo.sizeUnit': 'KB',

                        'selectedImagePreview.size': sizeImg,
                        'selectedImagePreview.sizeUnit': 'KB',

                        'socialSharingImage.size': sizeSocial,
                        'socialSharingImage.sizeUnit': 'KB',
                    })
                    i++
                    console.log(i);
                })
            })

        },
        GetSizeFile({ }, bytes) {
            return new Promise(async (resolve, reject) => {
                const thresh = 1024;

                if (Math.abs(bytes) < thresh) {
                    return bytes + ' B';
                }
                //si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']  : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']; // original
                // const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] all convertions
                const units = ['KB']
                let u = -1;
                const r = 10 ** 2;

                do {
                    bytes /= thresh;
                    ++u;
                } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

                resolve(parseFloat(bytes.toFixed(2)))
                //    resolve(bytes.toFixed(2) + ' ' + units[u])

            })

        },
        GetProTrainersList({ commit, getters }) {
            return new Promise(async (resolve, reject) => {
                await getDocs(collection(db, "proTrainersList"))
                    .then((querySnapshot) => {
                        let proTrainersList = [];
                        querySnapshot.forEach((doc) => {
                            let proTrainer = doc.data();
                            proTrainer.typeWorkout = 'proTrainer'
                            proTrainer.completedTimes = proTrainer.completedTimes ? proTrainer.completedTimes : 0;

                            const calories = proTrainer.accumulatedCalories ? proTrainer.accumulatedCalories : 0;
                            const mxp = proTrainer.accumulatedMXP ? proTrainer.accumulatedMXP : 0;
                            const completedTimes = proTrainer.completedTimes ? proTrainer.completedTimes : 0;

                            const avgMXP = completedTimes > 0 ? mxp / completedTimes : 0;
                            const avgCalories = completedTimes > 0 ? calories / completedTimes : 0;

                            proTrainer.avgMXP = Number(avgMXP.toFixed(1));
                            proTrainer.avgCalories = Number(avgCalories.toFixed(1));

                            proTrainer.counterReproductions = getters.getProTrainersCounterReproductor[proTrainer.id] ? getters.getProTrainersCounterReproductor[proTrainer.id] : 0
                            proTrainersList.push(proTrainer);
                        });
                        commit("SET_PRO_TRAINERS_LIST", proTrainersList);
                        resolve(proTrainersList);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GetCoachedClasses({ commit }) { //Get classes without 'counterReproductions'
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "proTrainersList"))
                    const coachedClassesList = []
                    querySnapshot.forEach((doc) => {
                        let coachedClass = doc.data()
                        coachedClassesList.push(coachedClass)
                    })
                    commit('SET_PRO_TRAINERS_LIST', coachedClassesList)
                    resolve(coachedClassesList)
                } catch (error) {
                    reject(error)
                }
            });
        },
        async GetProTrainersCounterReproductor({ commit }) {
            try {
                const count = await getCountFromServer(collection(db, "inAppEvents"), where("eventType", "==", EVENT_TYPES.WORKOUT_COMPLETED), where("type", "==", "coachedClass"));
                commit("SET_PRO_COUNTER_REPRODUCTOR", count.data().count);
                return count.data().count;
            } catch (error) {
                console.error("Error in GetProTrainersCounterReproductor:", error);
                return 0;
            }
            // return new Promise(async (resolve, reject) => {
            //     await getDoc(doc(db, "countersAnalytics", "workoutReproductions"))
            //         .then((querySnapshot) => {
            //             let counterReproductor = querySnapshot.data()
            //             commit("SET_PRO_COUNTER_REPRODUCTOR", counterReproductor);
            //             resolve(counterReproductor);
            //         }).catch((err) => {
            //             reject(err)
            //         })
            // });
        },
        GetProTrainersTakenInRangeDate({ commit, getters }, dateRange) {
            return new Promise(async (resolve, reject) => {
                const querySnapshot = await getDocs(query(collection(db, "timestampCoachedClasses"), where("timestamp", ">=", new Date(dateRange.startDate)), where("timestamp", "<=", new Date(dateRange.endDate))))
                    .then((querySnapshot) => {
                        let proTrainersList = getters.getProTrainersList.map((proTrainer) => {
                            proTrainer.takedWorkouts = []
                            querySnapshot.forEach((workoutSaved) => {
                                let takedWorkout = workoutSaved.data()
                                if (takedWorkout.id === proTrainer.id) {
                                    proTrainer.takedWorkouts.push(takedWorkout)
                                }
                            })
                            proTrainer.takedWorkoutsCounter = proTrainer.takedWorkouts.length
                            return proTrainer
                        })

                        commit("SET_PRO_TRAINERS_LIST", proTrainersList)
                        resolve(proTrainersList);
                    }).catch((err) => {
                        reject(err)
                    })
            })
        },
        GetProTrainersPaginatedFirstPage({ commit, getters }, itemsPerPage) {
            return new Promise(async (resolve, reject) => {
                if (getters.getProTrainersList.length > 0) {
                    commit("GO_UNSUBSCRIBE_PRO_TRAINERS_LIST");
                }
                const q = query(collection(db, "proTrainersList"), orderBy('name'), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                    let proTrainersList = [];
                    querySnapshot.forEach((doc) => {
                        let proTrainer = doc.data()
                        proTrainersList.push(proTrainer);
                    });
                    commit("SET_PRO_TRAINERS_LIST", proTrainersList);
                    resolve(proTrainersList);
                },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PRO_TRAINERS_LIST", unsubscribe);
            });
        },
        GetProTrainersNextPage({ commit, getters }, itemsPerPage) {
            return new Promise(async (resolve, reject) => {
                commit("GO_UNSUBSCRIBE_PRO_TRAINERS_LIST");
                const q = query(collection(db, "proTrainersList"), orderBy('name'), startAfter(getters.getProTrainersList[getters.getProTrainersList.length - 1].name), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                    let proTrainersList = [];
                    querySnapshot.forEach((doc) => {
                        let proTrainer = doc.data()
                        proTrainersList.push(proTrainer);
                    });
                    console.log(proTrainersList);
                    if (proTrainersList.length > 0) {
                        commit("SET_PRO_TRAINERS_LIST", proTrainersList);
                    }
                    resolve(proTrainersList);
                },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PRO_TRAINERS_LIST", unsubscribe);
            });
        },
        GetProTrainersPrevPage({ commit, getters }, itemsPerPage) {
            return new Promise(async (resolve, reject) => {
                commit("GO_UNSUBSCRIBE_PRO_TRAINERS_LIST");
                const q = query(collection(db, "proTrainersList"), orderBy('name', 'desc'), startAfter(getters.getProTrainersList[0].name), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                    let proTrainersList = [];
                    querySnapshot.forEach((doc) => {
                        let proTrainer = doc.data()
                        proTrainersList.push(proTrainer);
                    });
                    commit("SET_PRO_TRAINERS_LIST", proTrainersList);
                    resolve(proTrainersList);
                },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PRO_TRAINERS_LIST", unsubscribe);
            });
        },
        GoUnsuscribeGetProTrainersList({ commit }) {
            commit("GO_UNSUBSCRIBE_PRO_TRAINERS_LIST");
        },
        GoUnsuscribeGetProTrainersCounterReproductor({ commit }) {
            commit("GO_UNSUBSCRIBE_PRO_TRAINERS_COUNTER_REPRODUCTOR");
        },
        DeleteProTrainer({ }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                let storageRef = ref(storageInstance, proTrainer.principalVideo.ref);
                let storageRefImage = ref(storageInstance, proTrainer.selectedImagePreview.ref);

                await deleteObject(storageRefImage)
                    .then(async () => {
                        await deleteObject(storageRef)
                            .then(async () => {
                                await deleteDoc(doc(db, "proTrainersList", proTrainer.id))
                                    .then((res) => {
                                        updateDoc(doc(db, "countersAnalytics", "workoutReproductions"), {
                                            [proTrainer.id]: deleteField()
                                        })
                                        resolve(proTrainer.id);
                                    })
                                    .catch((err) => {
                                        reject(err);
                                    });
                            }).catch((errorImg) => {
                                console.log('errorImg deleting storage', errorImg);
                                // Uh-oh, an error occurred!
                            });
                        // File deleted successfully
                    }).catch((error) => {
                        console.log('error deleting storage', error);
                        // Uh-oh, an error occurred!
                    });
            });
        },
        UpdateProTrainer({ }, proTrainer) {
            return new Promise(async (resolve, reject) => {
                if (proTrainer.createdAt) {
                    delete proTrainer.createdAt
                }
                proTrainer.updatedAt = new Date()
                if (proTrainer.principalVideo.video) {
                    delete proTrainer.principalVideo.video
                }
                if (proTrainer.selectedImagePreview.img) {
                    delete proTrainer.selectedImagePreview.img
                }
                if (proTrainer.socialSharingImage.img) {
                    delete proTrainer.socialSharingImage.img
                }
                if (proTrainer.takedWorkouts) {
                    delete proTrainer.takedWorkouts
                }
                if (proTrainer.takedWorkoutsCounter >= 0) {
                    delete proTrainer.takedWorkoutsCounter
                }
                if (proTrainer.counterReproductions >= 0) {
                    delete proTrainer.counterReproductions
                }
                if (proTrainer.subscription && proTrainer.subscription != "") {
                    proTrainer.subscription = doc(db, "subscriptionsList", proTrainer.subscription.id)
                }
                await updateDoc(doc(db, "proTrainersList", proTrainer.id), proTrainer)
                    .then((res) => {
                        resolve(proTrainer.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetFiltersListsProTrainer({ commit }) {
            return new Promise(async (resolve, reject) => {
                await getDocs(collection(db, "proTrainersFilters"))
                    .then((querySnapshot) => {
                        let proTrainerFilters = [];
                        querySnapshot.forEach((doc) => {
                            let filterProtrain = doc.data();
                            filterProtrain.type = doc.id
                            proTrainerFilters.push(filterProtrain);
                        });
                        commit("SET_PRO_TRAINERS_FILTER_LIST", proTrainerFilters);
                        resolve(proTrainerFilters);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        AddNewTypeToListOfFiltersProTrain({ commit }, data) {
            return new Promise(async (resolve, reject) => {
                await updateDoc(doc(db, "proTrainersFilters", data.doc), {
                    // [data.array]: arrayUnion(data.name),
                    listFilters: arrayUnion({ name: data.name, children: data.children })
                })
                    .then((res) => {
                        commit("ADD_ANY_VALUE_PRO_TRAINERS_FILTER_LIST", data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })

        },
        DeleteTypeToListOfFiltersProTrain({ commit }, data) {
            return new Promise(async (resolve, reject) => {
                await updateDoc(doc(db, "proTrainersFilters", data.doc), {
                    // [data.array]: arrayRemove(data.name),
                    listFilters: arrayRemove(data.item)
                })
                    .then((res) => {
                        commit('DELETE_ANY_VALUE_PRO_TRAINERS_FILTER_LIST', data)
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        AddOrDeleteChildrenToListOfFiltersProTrain({ commit }, data) {
            return new Promise(async (resolve, reject) => {
                await updateDoc(doc(db, "proTrainersFilters", data.doc), {
                    listFilters: data.updatedArray
                })
                    .then((res) => {
                        commit("UPDATE_WITH_NEW_VALUES_PRO_TRAINERS_FILTER_LIST_CHILDREN", data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });

            })
        },
        CreateNewFilterProTrainer({ commit }, data) {
            return new Promise(async (resolve, reject) => {
                await setDoc(doc(db, "proTrainersFilters", data.doc), {
                    name: data.name,
                    listFilters: data.listFilters,
                })
                    .then((res) => {
                        commit("UPDATE_FILTER_LIST_PRO_TRAINER", data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });

            })
        },
        DeleteFilterProTrainer({ commit }, data) {
            return new Promise(async (resolve, reject) => {
                await deleteDoc(doc(collection(db, "proTrainersFilters"), data.doc))
                    .then((res) => {
                        commit("DELETE_VALUE_ROOT_FILTER_PRO_TRAINER", data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });

            })
        },
        async GetLeaderBoardProTrain({ commit }, proTrain) {
            try {
                const q = query(collection(db, "leaderboards", proTrain.id, "leaders"), orderBy('score', 'desc'))
                let gettedLeaderboard = await getDocs(q)
                const leaderboard = await Promise.all(gettedLeaderboard.docs.map(async (docSnapshot) => {
                    let leader = docSnapshot.data()
                    // Check if leader.user is a document reference or a string ID
                    let user;
                    if (typeof leader.user === 'string') {
                        user = await getDoc(doc(db, "users", leader.user))
                    } else {
                        // leader.user is already a document reference
                        user = await getDoc(leader.user)
                    }
                    leader.userInfo = user.data()
                    return leader
                }))
                commit("SET_ACTUAL_LEADERBOARD", leaderboard);
                return leaderboard;
            } catch (error) {
                console.error(error)
                return [];
            }
        },
        ClearLeaderBoardProTrain({ commit }) {
            commit("SET_ACTUAL_LEADERBOARD", []);
        },
        ResetLeadeboardProTrain({ commit }, deleteData) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Vue.axios.post(requestEndPoint.coachedClassesResetLeaderboards, deleteData, { headers: null })
                    resolve(res);
                } catch (error) {
                    console.error(error);
                }
            });
        },
        UpdateClassValue({ }, obj) {
            return new Promise(async (resolve, reject) => {
                try {
                    await updateDoc(doc(db, "proTrainersList", obj.id), obj.data);
                    resolve(obj.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        ResetMassiveAllLeadeboardsProTrain({ commit, getters }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Vue.axios.post(requestEndPoint.resetAllLeadersCoachedClasses, { uid: getters.getAdmin.uid }, { headers: null })
                    resolve(res);
                } catch (error) {
                    console.error(error);
                }
            });
        },
        //Type of Exercise
        GetProTrainerTypeOfExerciseList({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "proTrainerTypeOfExerciseList"))
                    const proTrainerTypeOfExerciseList = []
                    querySnapshot.forEach((doc) => {
                        proTrainerTypeOfExerciseList.push(doc.data())
                    })
                    commit('SET_PRO_TRAINER_TYPE_OF_EXERCISE_LIST', proTrainerTypeOfExerciseList)
                    resolve(proTrainerTypeOfExerciseList)
                } catch (error) {
                    reject(error)
                }
            })
        },
        CreateProTrainerTypeOfExercise({ }, proTrainerTypeExercise) {
            return new Promise(async (resolve, reject) => {
                try {
                    const ref = doc(collection(db, "proTrainerTypeOfExerciseList"));
                    const newProTrainerTypeOfExercise = await getDoc(ref);
                    proTrainerTypeExercise.id = ref.id;
                    await setDoc(ref, proTrainerTypeExercise)
                    resolve(newProTrainerTypeOfExercise.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateProTrainerTypeOfExercise({ }, type) {
            return new Promise(async (resolve, reject) => {
                try {
                    await updateDoc(doc(collection(db, "proTrainerTypeOfExerciseList"), type.id), type)
                    resolve(type.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteProTrainerTypeOfExercise({ }, type) {
            return new Promise(async (resolve, reject) => {
                try {
                    await deleteDoc(doc(collection(db, "proTrainerTypeOfExerciseList"), type.id))
                    resolve(type.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        //Type of Body
        GetProTrainerTypeOfBodyList({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "proTrainerTypeOfBodyList"))
                    const proTrainerTypeOfBodyList = []
                    querySnapshot.forEach((doc) => {
                        proTrainerTypeOfBodyList.push(doc.data())
                    })
                    commit('SET_PRO_TRAINER_TYPE_OF_BODY_LIST', proTrainerTypeOfBodyList)
                    resolve(proTrainerTypeOfBodyList)
                } catch (error) {
                    reject(error)
                }
            })
        },
        CreateProTrainerTypeOfBody({ }, proTrainerTypeBody) {
            return new Promise(async (resolve, reject) => {
                try {
                    const ref = doc(collection(db, "proTrainerTypeOfBodyList"));
                    const newProTrainerTypeOfBody = await getDoc(ref);
                    proTrainerTypeBody.id = ref.id;
                    await setDoc(ref, proTrainerTypeBody)
                    resolve(newProTrainerTypeOfBody.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        UpdateProTrainerTypeOfBody({ }, type) {
            return new Promise(async (resolve, reject) => {
                try {
                    await updateDoc(doc(collection(db, "proTrainerTypeOfBodyList"), type.id), type)
                    resolve(type.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteProTrainerTypeOfBody({ }, type) {
            return new Promise(async (resolve, reject) => {
                try {
                    await deleteDoc(doc(collection(db, "proTrainerTypeOfBodyList"), type.id))
                    resolve(type.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        SendNotificationAndPost({ }, { workoutId, workoutType }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Vue.axios.post("https://us-central1-maxfit-app.cloudfunctions.net/createWorkoutNotification", { workoutId, workoutType }, { headers: null })
                    resolve(res);
                } catch (error) {
                    reject(error);
                }
            });
        }
    },
    getters: {
        getLoadingStatus(state) {
            return state.loadingStatus;
        },
        getLoadingImage(state) {
            return state.statusImage;
        },
        getProTrainersList(state) {
            return state.proTrainersList;
        },
        getProTrainersCounterReproductor(state) {
            return state.proTrainersCounterReproductor;
        },
        getProTrainDateRanges(state) {
            return state.dateRange
        },
        getProTrainDateRangesChart(state) {
            return state.dateRangeChart
        },
        getProTrainerFilters(state) {
            return state.proTrainerFilters
        },
        getLoadingSocialSharingImage(state) {
            return state.statusSocialSharingImage
        },
        getProTrainerLeaderboard(state) {
            return state.proTrainerLeaderboard
        },
        getProTrainerTypeOfExerciseList(state) {
            return state.proTrainerTypeOfExercise

        },
        getProTrainerTypeOfBodyList(state) {
            return state.proTrainerTypeOfBody

        }
    },
};